import mockPost from './mockPost'

// @ts-expect-error TS(7031) FIXME: Binding element 'channel' implicitly has an 'any' ... Remove this comment to see the full error message
export default function mockPosts({ channel, count, service = 'instagram' }) {
  const posts = []

  for (let i = 0; i < count; i++) {
    posts.push(
      mockPost({
        service,
        override: {
          channelServiceId: channel,
        },
      }),
    )
  }

  return posts
}
